var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-client-table", {
    staticClass: "card mb-0 vue-custom-table no-pagination",
    attrs: {
      data: _vm.getClients,
      columns: _vm.columns,
      options: _vm.tableOptions,
      name: _vm.tableName,
    },
    scopedSlots: _vm._u([
      {
        key: "h__board",
        fn: function () {
          return [
            _c("div", { staticClass: "dropdown-filters-wrapper" }, [
              _c(
                "a",
                {
                  staticClass: "clickable",
                  attrs: { "data-toggle": "dropdown" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$tc("global.doorr.board", 1)) +
                      "\n        "
                  ),
                  _c("icon", { attrs: { name: "filter" } }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dropdown-menu" },
                [
                  _c("inactive-clients-filter-dropdown", {
                    model: {
                      value: _vm.boardFilters,
                      callback: function ($$v) {
                        _vm.boardFilters = $$v
                      },
                      expression: "boardFilters",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "fullName",
        fn: function (ref) {
          var row = ref.row
          return [
            _c("div", { staticClass: "d-flex" }, [
              _c(
                "div",
                { staticClass: "position-relative d-none d-md-block" },
                [
                  !row.read
                    ? _c("i", {
                        staticClass:
                          "position-absolute text-white text-center email-badge-table bg-danger",
                        attrs: { "aria-hidden": "true" },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "profile-avatar",
                    _vm._b(
                      { staticClass: "client-avatar mr-3" },
                      "profile-avatar",
                      Object.assign({}, row),
                      false
                    )
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass:
                    "regular my-auto text-primary text-capitalize bold",
                  attrs: {
                    "data-toggle": "tooltip",
                    "data-original-title": _vm.$t(
                      "inactive-clients.viewClientProfile"
                    ),
                    href: "#/board/" + row.boardId + "/profile/" + row.id,
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(row.givenName) +
                      " " +
                      _vm._s(row.familyName) +
                      "\n      "
                  ),
                ]
              ),
            ]),
          ]
        },
      },
      {
        key: "referrer",
        fn: function (ref) {
          var row = ref.row
          return [
            row.referrerId
              ? _c(
                  "div",
                  {
                    staticClass:
                      "regular text-gray my-auto mx-auto text-capitalize",
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(row.referrer.givenName) +
                        " " +
                        _vm._s(row.referrer.familyName) +
                        "\n    "
                    ),
                  ]
                )
              : _vm._e(),
          ]
        },
      },
      {
        key: "createdAt",
        fn: function (ref) {
          var row = ref.row
          return [
            _c(
              "div",
              { staticClass: "regular text-gray m-0 text-capitalize" },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.dateConverter(row.createdAt)) +
                    "\n    "
                ),
              ]
            ),
          ]
        },
      },
      {
        key: "updatedAt",
        fn: function (ref) {
          var row = ref.row
          return [
            _c(
              "div",
              { staticClass: "regular text-gray m-0 text-capitalize" },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.dateConverter(row.updatedAt)) +
                    "\n    "
                ),
              ]
            ),
          ]
        },
      },
      {
        key: "board",
        fn: function (ref) {
          var row = ref.row
          return [
            _c("div", { staticClass: "d-flex justify-content-end" }, [
              _c(
                "div",
                { staticClass: "d-xl-block d-none" },
                [
                  _c(
                    "simple-button",
                    {
                      attrs: {
                        type: "white",
                        "class-name": "btn-sm p-0 border-0",
                        loading: _vm.isTransferLoading(row.id),
                        "loading-succeeded": _vm.transferSucceeded(row.id),
                      },
                    },
                    [
                      _c("boards-dropdown", {
                        attrs: {
                          text: row.boardName,
                          profile: {
                            details: {
                              statusLabelId: row.statusLabelId,
                            },
                            statusLabels: {
                              0: {
                                boardId: row.boardId,
                              },
                            },
                          },
                          update: true,
                          "client-profile-id": row.id,
                          "current-board": row.boardId,
                          inactive: true,
                          "toggle-class":
                            "text-truncate inactive-client-board-dropdown",
                          "menu-class": "inactive-client-board-dropdown-menu",
                        },
                        on: {
                          "transfer-profile": function (data) {
                            return _vm.transferProfile(data)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass:
                    "btn btn-sm btn-primary bold d-xl-block d-none ml-3",
                  on: {
                    click: function ($event) {
                      return _vm.handleClick(row.id, row.boardId)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("inactive-clients.reactivate")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "dropleft d-flex d-xl-none" }, [
                _c(
                  "a",
                  {
                    staticClass: "grey-text text-darken-4 clickable d-xl-none",
                    attrs: { "data-toggle": "dropdown" },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("more_vert"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "dropdown-menu",
                    staticStyle: { overflow: "visible !important" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "dropleft dropdown-submenu dropdown-item wide px-4",
                      },
                      [
                        _c("boards-dropdown", {
                          attrs: {
                            text: row.boardName,
                            profile: {
                              details: {
                                statusLabelId: row.statusLabelId,
                              },
                              statusLabels: {
                                0: {
                                  boardId: row.boardId,
                                },
                              },
                            },
                            "fetch-boards": false,
                            update: true,
                            "client-profile-id": row.id,
                            "current-board": row.boardId,
                            inactive: true,
                            "toggle-class":
                              "text-truncate inactive-client-board-dropdown",
                            "menu-class": "inactive-client-board-dropdown-menu",
                            "drop-left": "",
                            "open-on-hover": "",
                          },
                          on: {
                            "transfer-profile": function (data) {
                              return _vm.transferProfile(data)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "dropdown-divider d-none d-md-block",
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "dropdown-item clickable wide px-4",
                        on: {
                          click: function ($event) {
                            return _vm.handleClick(row.id, row.boardId)
                          },
                        },
                      },
                      [
                        _c("button", { staticClass: "btn btn-white" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("inactive-clients.reactivate")) +
                              "\n            "
                          ),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }